/**
 * Distributori (DSO) e formato del codice cabina primaria.
 *
 * Il DSO era un campo di testo libero: ogni operatore lo scriveva a modo suo
 * ("e-distribuzione", "Enel", "E-Distribuzione SpA") e il dato non era
 * aggregabile né confrontabile con i tracciati GSE (INB-113). L'elenco copre i
 * distributori con la quota maggiore di POD in Italia; `other` resta come
 * valvola di sfogo per i distributori locali minori (in Italia sono oltre 120).
 */
export const DSO_OPTIONS = [
	{ value: 'e-distribuzione', label: 'e-distribuzione (Gruppo Enel)' },
	{ value: 'areti', label: 'Areti (Acea, Roma)' },
	{ value: 'unareti', label: 'Unareti (A2A, Milano/Brescia)' },
	{ value: 'ireti', label: 'IRETI (Iren)' },
	{ value: 'edyna', label: 'Edyna (Alto Adige)' },
	{ value: 'deval', label: 'DEVAL (Valle d’Aosta)' },
	{ value: 'set-distribuzione', label: 'SET Distribuzione (Trentino)' },
	{ value: 'asm-terni', label: 'ASM Terni' },
	{ value: 'aim-vicenza', label: 'AIM Vicenza' },
	{ value: 'other', label: 'Altro distributore locale' },
] as const;

export type DsoValue = (typeof DSO_OPTIONS)[number]['value'];

/**
 * Le stesse opzioni in forma mutabile, come le vogliono i menu a tendina dei
 * form: `DSO_OPTIONS` è `as const` per derivarne {@link DsoValue}, ma un array
 * readonly non è assegnabile alle props `options`.
 */
export const DSO_SELECT_OPTIONS: { value: string; label: string }[] = DSO_OPTIONS.map((o) => ({
	value: o.value,
	label: o.label,
}));

/**
 * Codice area convenzionale GSE: 11 caratteri alfanumerici (es. AC001E00934).
 *
 * È il codice dell'area convenzionale su cui il GSE verifica che tutti i POD
 * della configurazione insistano: se è malformato la verifica fallisce a valle,
 * quindi conviene segnalarlo al momento dell'inserimento.
 */
export const CABINA_PRIMARIA_PATTERN = /^AC\d{3}[A-Z]\d{5}$/;

/** Esempio di codice cabina primaria ben formato, usato come segnaposto. */
export const CABINA_PRIMARIA_PLACEHOLDER = 'AC001E00934';

/**
 * Valida il codice cabina primaria. Il campo vuoto è valido: si compila più
 * tardi, quando il DSO comunica l'area convenzionale.
 */
export function isValidCabinaPrimaria(value: string): boolean {
	const trimmed = value.trim();
	return trimmed === '' || CABINA_PRIMARIA_PATTERN.test(trimmed);
}
